import React from "react";
import { useInView } from "react-intersection-observer";
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from{
    opacity:0;
  }
  to{
    opacity:1;
  }
`;

const AnimatedWrapper = styled.div`
  animation: ${fadeIn} 2.5s;
`;

const Wrapper = styled.div`
    opacity:0;
`;

export default function FadeIn({ children }) {
  const [ref, inView] = useInView({
    threshold: 0,
    triggerOnce: true
  });

  return (
    <div ref={ref}>
      {inView ? <AnimatedWrapper>{children}</AnimatedWrapper> : <Wrapper>{children}</Wrapper>}
    </div>
  );
}
